/**
 *
 * NetworkClientCount
 *
 */

import CustomHorizontalBarChart from './CustomHorizontalBarChart.jsx';
import './CustomHorizontalBarChart.less';

export default CustomHorizontalBarChart;
